import React from "react";
import {Alert, Button, Divider, Paper, Stack, Tooltip, Typography} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import CancelIcon from "@mui/icons-material/Cancel";
import PersonIcon from "@mui/icons-material/Person";
import DescriptionIcon from "@mui/icons-material/Description";
import DocumentScannerIcon from "@mui/icons-material/DocumentScanner";
import StarIcon from "@mui/icons-material/Star";
import ButtonMenu from "./ButtonMenu";

export default function BookingActions({
                                         reservation,
                                         loadingChangeStatus,
                                         onStatusChange,
                                         onEdit,
                                         onCancel,
                                         onViewClient,
                                         onViewContracts,
                                         onScanContract,
                                         onGenerateQuote,
                                         onSendMail,
                                         onGenerateContract,
                                         setConfirmSetReadyOpen,
                                         setConfirmCompleteOpen,
                                         setConfirmDialogToSendReviewEmailOpen
                                       }) {
  if (!reservation) return null;

  return (
    <Paper sx={{p: 2, width: "100%"}}>
      <Typography variant="subtitle1">Actions rapides</Typography>

      <Divider sx={{my: 1}}/>
      <Typography variant="subtitle2">Gestion de la réservation</Typography>

      <Stack spacing={1} sx={{mt: 1}}>
        {reservation.status.key === "cancelled" &&
          <Alert severity="error">Cette réservation a été annulée.</Alert>}

        {reservation.status.key === "draft" && reservation.depositPercentage > 0 &&
          <Tooltip
            title="Lorsque la réservation est finalisée et prête à être envoyée au client pour paiement de l'acompte.">
            <Button
              disabled={loadingChangeStatus}
              sx={{width: "100%"}}
              variant="contained"
              onClick={() => onStatusChange("pending")}
            >
              Marquer En attente de l'acompte
            </Button>
          </Tooltip>
        }

        {((reservation.status.key === "pending") || (reservation.status.key === "draft" && reservation.depositPercentage === 0)) &&
          <Tooltip title="Si la réservation est confirmée et que le paiement d'acompte est reçu.">
            <Button
              disabled={loadingChangeStatus}
              sx={{width: "100%"}}
              variant="contained"
              onClick={() => onStatusChange("confirmed")}
            >
              {reservation.depositPercentage > 0 ? "Marquer : Acompte reçu" : "Marquer : Devis accepté"}
            </Button>
          </Tooltip>
        }

        {reservation.status.key === "confirmed" &&
          <Tooltip title="Si le paiement final est reçu et que tout est prêt pour l'événement.">
            <Button
              disabled={loadingChangeStatus}
              sx={{width: "100%"}}
              variant="contained"
              onClick={() => setConfirmSetReadyOpen(true)}
            >
              Marquer : Solde reçu
            </Button>
          </Tooltip>
        }

        {reservation.status.key === "ready" &&
          <Tooltip title="Lorsque l'événement commence et que les clients arrivent.">
            <Button
              disabled={loadingChangeStatus}
              sx={{width: "100%"}}
              variant="contained"
              onClick={() => onStatusChange("in_progress")}
            >
              Marquer En cours
            </Button>
          </Tooltip>
        }

        {reservation.status.key === "in_progress" &&
          <Tooltip title="Lorsque l'événement est terminé et que les clients sont partis.">
            <Button
              disabled={loadingChangeStatus}
              sx={{width: "100%"}}
              variant="contained"
              onClick={() => setConfirmCompleteOpen(true)}
            >
              Marquer Terminée
            </Button>
          </Tooltip>
        }

        {reservation.status.key === "completed" &&
          <React.Fragment>
            <Alert severity="success">Cette réservation est terminée.</Alert>
            <Button
              startIcon={<StarIcon/>}
              sx={{width: "100%"}}
              variant="outlined"
              onClick={() => setConfirmDialogToSendReviewEmailOpen(true)}
            >
              Envoyer le mail d'avis
            </Button>
          </React.Fragment>
        }

        {reservation.status.key !== "cancelled" &&
          <Button
            startIcon={<EditIcon/>}
            sx={{width: "100%"}}
            variant="outlined"
            onClick={onEdit}
          >
            Modifier réservation
          </Button>
        }

        {(reservation.status.key !== "cancelled" && reservation.status.key !== "completed") &&
          <Button
            disabled={loadingChangeStatus}
            startIcon={<CancelIcon/>}
            sx={{width: "100%"}}
            color="error"
            variant="outlined"
            onClick={onCancel}
          >
            Annuler la réservation
          </Button>
        }

        <Divider/>
        <Typography variant="subtitle2">Actions</Typography>

        <Button
          fullWidth
          startIcon={<PersonIcon/>}
          variant="contained"
          onClick={onViewClient}
        >
          Voir la fiche client
        </Button>

        <Divider/>

        <Typography variant="subtitle2">Documents</Typography>
        <Stack direction="column" spacing={1} sx={{mt: 1}}>
          <ButtonMenu
            name={"Devis"}
            startIcon={<DescriptionIcon/>}
            onView={onGenerateQuote}
            onSend={() => onSendMail('estimate')}
          />
          {reservation.contracts && (reservation.contracts.length > 1 || (reservation.contracts.length === 1 && reservation.contracts[0].is_signed)) ? (
            <Button
              fullWidth
              startIcon={<DescriptionIcon/>}
              variant="outlined"
              onClick={onViewContracts}
              disabled={reservation.status.key === "draft"}
            >
              Contrats de location
            </Button>
          ) : (
            <ButtonMenu
              name={"Contrat de location"}
              startIcon={<DescriptionIcon/>}
              onView={() => onGenerateContract()}
              onSend={() => onSendMail('contract')}
              disabled={reservation.status.key === "draft"}
            />
          )}

          <Button
            variant='outlined'
            onClick={onScanContract}
            startIcon={<DocumentScannerIcon/>}
            disabled={reservation.status.key === "draft"}
          >
            Scanner le contrat signé
          </Button>
        </Stack>
      </Stack>
    </Paper>
  );
}
